// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__3flG9","content":"Consent_content__17uhT","footer":"Consent_footer__JA2TZ"};